import apiClient from '../../../services/apiClient';
import type { AnalysisData, AnalysisRanges } from './analysisTypes';

export const getAnalysis = async (
  generalKey: string,
  stageNumber: number,
): Promise<AnalysisData> => {
  const response = await apiClient.get<AnalysisData>(
    `/direct-shear/${generalKey}/stages/${stageNumber}/analysis`,
  );
  return response.data;
};

export const saveAnalysisRanges = async (
  generalKey: string,
  stageNumber: number,
  ranges: AnalysisRanges,
): Promise<AnalysisData> => {
  const response = await apiClient.put<AnalysisData>(
    `/direct-shear/${generalKey}/stages/${stageNumber}/analysis`,
    ranges,
  );
  return response.data;
};
